import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { llmUrl, url } from '../utils/config';
import { btnRound, inputStyleTwo } from '../utils/style';
import arrowBlack from '../assets/icons/arrow_black.png'
import { useNavigate } from 'react-router-dom';
import reload from '../assets/icons/refresh.png';
import ReactMarkdown from 'react-markdown';

function ChatGpt({ setShowChatScreen }) {
  const [cars, setCars] = useState([])
  const [conversation, setConversation] = useState(JSON.parse(window.sessionStorage.getItem('conversation')) || []);
  const [prompt, setPrompt] = useState('')
  const [promptState, setPromptState] = useState('Manufacturer')
  const [disabled, setDisabled] = useState(false)
  const [carInfo, setCarInfo] = useState({})
  const [loading, setLoading] = useState(false)
  const divRef = useRef(null)
  const navigate = useNavigate();

  const makeList = useMemo(() => {
    return [...new Set(cars.map(car => car.make))].sort();
  }, [cars]);

  useEffect(() => { fetchCars() }, [])

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollTop = divRef.current.scrollHeight
    }
  }, [conversation])


  useEffect(() => {
    const timeout = setTimeout(updatePromptState, 1000);
    return () => clearTimeout(timeout);
  }, [promptState]);


  async function fetchCars() {
    try {
      const token = window.localStorage.getItem('token');
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(url + '/cars', { headers })
      setCars(data.data)
    } catch (error) {
      console.log(error)
    }
  }

  function updatePromptState() {
    setDisabled(true)
    const newData = [...conversation];

    switch (promptState) {
      case 'Manufacturer':
        newData.push({ response: 'Enter Manufacturer' })
        setConversation(newData)
        break;

      case 'Model':
        newData.push({ response: 'Enter Model' })
        setConversation(newData)
        break;

      case 'Year':
        newData.push({ response: 'Enter Year' })
        setConversation(newData)
        break;

      default:
        break;
    }

    setDisabled(false)
  }

  function updateCarInfo(prompt) {
    const newData = [...conversation, { prompt }];
    let nextState = '';
    const updatedCarInfo = { ...carInfo };

    if (promptState === 'Manufacturer') {
      updatedCarInfo.manufacturer = prompt;
      nextState = 'Model';
    } else if (promptState === 'Model') {
      updatedCarInfo.model = prompt;
      nextState = 'Year';
    } else if (promptState === 'Year') {
      updatedCarInfo.year = prompt;
      newData.push({ response: 'Please type your enquiry' });
    }

    setConversation(newData);
    setCarInfo(updatedCarInfo);
    setPromptState(nextState);
    setPrompt('');
  }


  function reset() {
    if (conversation.length === 1) {
      return
    }
    setConversation([]);
    window.sessionStorage.removeItem('conversation')
    setCarInfo({})
    setPrompt('')
    setPromptState('Manufacturer')
  }

  async function handleSendQuery() {
    if (prompt.length === 0) return;

    const newData = [...conversation, { prompt }, { response: '', isStreaming: true }];
    setConversation(newData);
    setPrompt('');
    setLoading(true);

    try {
      const reqUrl = llmUrl + '/chatgpt'; // your streaming endpoint
      const res = await fetch(reqUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: prompt, ...carInfo }),
      });

      if (!res.body) throw new Error('No response body');

      const reader = res.body.getReader();
      const decoder = new TextDecoder('utf-8');

      let resultText = '';

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          setConversation(prev => {
            const updated = [...prev];
            updated[updated.length - 1] = { response: resultText };
            window.sessionStorage.setItem('conversation', JSON.stringify(updated));
            return updated;
          });
          break;
        }

        const chunk = decoder.decode(value, { stream: true });
        resultText += chunk;

        setConversation(prev => {
          const updated = [...prev];
          updated[updated.length - 1] = { response: resultText, isStreaming: true };
          return updated;
        });
      }

    } catch (error) {
      console.error(error);
      const updatedData = [...conversation, { prompt }, { response: 'Something went wrong.' }];
      setConversation(updatedData);
    }

    setLoading(false);
  }


  function getModelList() {
    const model = []
    cars.filter(car => car.make === carInfo.manufacturer).forEach(car => { if (!model.includes(car.model)) model.push(car.model) });
    return model.sort();
  }

  return (
    <div className='w-screen fixed top-0 left-0 right-0 bottom-0 pb-12 pt-16 bg-white'>
      <div className="flex flex-col h-[100%] px-4">
        <div className='flex gap-4 items-center justify-between'>
          <div className='flex gap-4 items-center'>
            <button className={btnRound} onClick={() => navigate(-1)}>
              <img src={arrowBlack} height={20} width={20} />
            </button>
            <h2 className="text-xl font-bold">RollnCharge GPT</h2>
          </div>
          <div className='cursor-pointer'>
            <img onClick={() => reset()} src={reload} height={20} width={20} />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto bg-gray-50 p-4 rounded shadow" ref={divRef}>
          {conversation.map((convo, index) => {
            const isPrompt = !!convo.prompt;
            return (
              <div
                key={index}
                className={`flex rounded-md ${isPrompt ? 'justify-end text-black' : 'text-blue-700'
                  }`}
              >
                <span className="bg-gray-100 p-2 mb-2 rounded-md max-w-[90%]">
                  {isPrompt ? convo.prompt : (
                    convo.isStreaming && convo.response.length === 0
                      ? <div className="flex items-center space-x-1 text-gray-800 font-extrabold text-2xl">
                        <span className="animate-dot" style={{ animationDelay: '0s' }}>.</span>
                        <span className="animate-dot" style={{ animationDelay: '0.2s' }}>.</span>
                        <span className="animate-dot" style={{ animationDelay: '0.4s' }}>.</span>
                        <span className="animate-dot" style={{ animationDelay: '0.6s' }}>.</span>
                      </div>
                      : <ReactMarkdown>{convo.response}</ReactMarkdown>
                  )}
                </span>
              </div>
            );
          })}
        </div>

        {
          promptState === 'Manufacturer' || promptState === 'Model' || promptState === 'Year' ?
            <select onChange={e => { updateCarInfo(e.target.value) }} className={inputStyleTwo}>
              <option>--Select {promptState}--</option>
              {
                promptState === 'Manufacturer' &&
                makeList.map((make, ind) => <option key={ind} value={make}>{make}</option>)
              }
              {
                promptState === 'Model' &&
                getModelList().map((model, index) =>
                  <option key={index} value={model}>{model}</option>
                )
              }
              {
                promptState === 'Year' &&
                cars.filter(car => car.make === carInfo.manufacturer && car.model === carInfo.model).sort((a, b) => a.year - b.year).map((car, index) =>
                  <option key={index} value={car.year}>{car.year}</option>
                )
              }
            </select>
            :
            <div className="mt-4 flex">
              <input
                type="text"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder="Type a prompt"
                className="flex-1 p-2 border rounded-l-lg border-gray-300 focus:outline-none"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSendQuery()
                  }
                }}
              />
              <button
                onClick={handleSendQuery}
                className="bg-blue-500 text-white p-2 rounded-r-lg hover:bg-blue-600"
                disabled={disabled || loading}
              >
                Send
              </button>
            </div>
        }
      </div>
    </div>
  );
};

export default ChatGpt;
